import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';

export function* bulkAdmitEntrySaga() {
  yield call(SignalingSocket.send, {
    event: 'bulkAdmitUserAccess',
  });
}
